import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { getFormData } from "src/app/shared/helpers/utils";
import { NgbActiveModal, NgbDate, NgbDatepickerConfig } from "@ng-bootstrap/ng-bootstrap";
import { HttpService } from "src/app/services/http.service";
import { WithdrawFundsFormProvider } from "../../withdrawFunds-form-provider";
import { WithdrawFundsHttpService } from "../../common/services/withdrawFunds-http.service";
import { WithdrawFund } from "src/app/shared/interfaces/withdraw-fund-response.interface";
import { InvestmentsHttpService } from "src/app/investments/common/services/investments-http.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import { INTERMEDIARY_ID } from "src/app/shared/enums/common.enum";
import { InvestorsHttpService } from "src/app/investors/common/services/Investors-http.service";
import { InvestorsByIdResponseInterface } from "src/app/shared/interfaces/Investors-response.interface";
import { Subscription } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { InvestmentsResponseInterface } from "src/app/shared/interfaces/investments-response.interface";
import {
  InvestorStatementHttpService
} from "../../../investor-statement/common/services/investor-statement-http.service";
import { SpinnerService } from "@shared/services/spinner.service";
import { convertISONumberToNormal, formatSimpleNumber } from "@shared/helpers/v2";

@Component({
  selector: 'app-withdraw-funds',
  templateUrl: './withdraw-funds.component.html',
  styleUrls: ['./withdraw-funds.component.scss'],
})
export class WithdrawFundsComponent implements OnInit {
  WithdrawFundForm: FormGroup;
  // todo need remove when can get from backend side
  tooltipData = {
    type: 'Type',
    ccy: 'Currency',
    amount: 'Amount',
    note: 'Note',
    investorId: 'Investor',
    faceValue: 'Face Value',
    date: 'Date',
    product: 'Product',
  };
  isSubmitted = false;
  noteText = 'These funds will be remitted to:';
  iban = 'IBAN';
  private changeSubscription: Subscription = new Subscription();
  type: { id: string; name: string }[];
  WithdrawFundData: WithdrawFund;
  allCurrencyBankAccountData: any = [];
  investors: { id: string; name: string }[];
  product: { id: string; name: string }[];
  allCcyData: { id: string; name: string }[];
  intermediaryId = INTERMEDIARY_ID;
  investorId: string;
  financialStatementData: any[] = [];
  currentDate = moment().format('YYYY-MM-DD');
  financialStatementsLatestList: any[] = [];
  currentBalance: number;
  private isUpdatingAmount = false;

  constructor(
    private withdrawFundsHttpService: WithdrawFundsHttpService,
    private investmentsHttpService: InvestmentsHttpService,
    private investorsHttpService: InvestorsHttpService,
    private withdrawFundsFormProvider: WithdrawFundsFormProvider,
    public activeModal: NgbActiveModal,
    private config: NgbDatepickerConfig,
    private http: HttpService,
    private route: ActivatedRoute,
    private investorStatementHttpService: InvestorStatementHttpService,
    private spinnerService: SpinnerService,
  ) {
    this.initializeIntermediaryId();
  }

  ngOnInit(): void {
    this.getAllInvestorsLatestBalances();
    this.investorId = this.route.snapshot.queryParamMap.get('id') || '';
    this.WithdrawFundForm = this.withdrawFundsFormProvider.initWithdrawFundsForm(this.WithdrawFundData);
    if (this.investorId) {
      this.WithdrawFundForm.get('investorId')?.setValue(this.investorId);
      this.getInvestorById(this.investorId);
      this.getInvestmentsById(this.investorId);
      this.setPrePopulatedValue();
    }
    this.getDropDownsData();
    this.subscribeToValueChanges();
  }

  initializeIntermediaryId(): void {
    const storedData = localStorage.getItem('userData');
    const userDetails = storedData ? JSON.parse(storedData) : {};
    this.intermediaryId = userDetails.entityRoleId || null;
  }

  private getAllInvestorsLatestBalances(): void {
    this.investorStatementHttpService.getFinancialStatementLatestList()
      .subscribe({
        next: (response: any) => {
          this.financialStatementsLatestList = response.items || [];
          this.calculateBalance();
        },
        error: (error) => {
          this.financialStatementsLatestList = [];
        },
      })
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.WithdrawFundForm.invalid) {
      return;
    }
    let rawData = this.WithdrawFundForm.value;
    delete rawData.fullRedemption;
    rawData = getFormData(rawData);
    rawData.intermediaryId = this.intermediaryId.toString();
    rawData.investorId = rawData.investorId.toString();
    rawData.faceValue = Number(rawData.faceValue.replace(/,/g, ''));
    this.doCreate(rawData);
  }

  onSelect(event:any): void {
    if (event?.id) {
      this.getInvestorById(event.id);
    } else {
      this.iban = 'IBAN';
    }
  }

  doCreate(data: any): void {
    this.spinnerService.setShowSpinner(true);
    this.investmentsHttpService.postData('investments', data).subscribe({
      next: (response: any) => {
        this.spinnerService.setShowSpinner(false);
        this.closeModal();
        this.WithdrawFundForm.reset();
        Swal.fire({
          icon: 'success',
          text: 'Withdrawal request submitted successfully.',
          showConfirmButton: false,
          timer: 5000,
        });
      },
      error: (error) => {
        this.spinnerService.setShowSpinner(false);
        let errorMessages = error.error.message;
        if (typeof errorMessages === 'string') {
          errorMessages = [errorMessages];
        }
        const containsNoReceiptError = errorMessages.some((msg: string | string[]) => msg.includes('There is no receipt investment'));
        const containsFutureDateError = errorMessages.some((msg: string | string[]) => msg.includes('maximal allowed date for'));
        const defaultMessage = containsNoReceiptError || containsFutureDateError
          ? errorMessages.join(', ')
          : 'Error';
        Swal.fire({
          icon: 'error',
          text: defaultMessage,
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        });
      },
    });
  }

  private getDropDownsData(): void {
    this.withdrawFundsHttpService.getFilterData().subscribe((investmentsFilterData) => {
      investmentsFilterData.types.sort((a, b) => a.localeCompare(b));
      this.type = [
        ...(investmentsFilterData.types.map((type) => ({
          id: type,
          name: type,
        })) || []),
      ];

      this.product = [
        ...(investmentsFilterData.products.map((product) => ({
          id: product,
          name: product,
        })) || []),
      ];

      /*this.investors = [
        ...(investmentsFilterData.investors
          .sort((a: any, b: any) => {
            const nameA = a?.name.toUpperCase();
            const nameB = b?.name.toUpperCase();
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          })
          .map((investor: any) => ({
            id: investor.id,
            name: `${investor.id} - ${investor?.name || ''}`,
          })) || []),
      ];*/

      this.investmentsHttpService.getInvestorsFilterData().subscribe((investor: any) => {
        this.investors = [
          ...(investor.items
            .sort((a: any, b: any) => {
              const nameA = a.entity?.name.toUpperCase();
              const nameB = b.entity?.name.toUpperCase();
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            })
            .map((investor: any) => {
              const cleanId = investor.id?.split('-')[0];

              return {
                id: cleanId,
                name: `${cleanId} - ${investor?.entity?.name || ''}`,
              };
            }) || []),
        ];
      });
    });

    this.http.getCurrencyWithBank().subscribe((response: any) => {
      this.allCcyData = [
        ...(response.map((ccy: any) => ({
          id: ccy.currency,
          name: ccy.currency,
        })) || []),
      ];
    });
  }

  getInvestorById(id: string) {
    this.investorsHttpService.getInvestorById(id).subscribe({
      next: (response: InvestorsByIdResponseInterface[]) => {
        if (response[0].entity?.bankAccounts && response[0].entity?.bankAccounts.length > 0) {
          const firstIban = this.getFirstIban(response[0].entity.bankAccounts);
          // this.iban = response.entity.bankAccounts[0].iban;
          if (firstIban) {
            this.iban = firstIban;
          } else {
            this.showNoIBANFound();
          }
        } else {
         this.showNoIBANFound();
        }
      },
      error: (error) => {
        Swal.fire({
          icon: 'error',
          text: error?.error?.message || 'Error',
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        });
      },
    });
  }

  private showNoIBANFound(): void {
    this.iban = 'IBAN';
    Swal.fire({
      icon: 'error',
      text: 'No IBAN found for the investor.',
      showConfirmButton: true,
      confirmButtonText: 'Ok',
    });
  }

  getFirstIban(accounts: any[]): string | null {
    const accountWithIban = accounts.find(acc => !!acc.iban?.trim());
    return accountWithIban ? accountWithIban.iban : null;
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  subscribeToValueChanges() {
    this.changeSubscription.add(
      this.WithdrawFundForm.get('faceValue')?.valueChanges.subscribe((faceValue) => {

        // If Full Redemption is checked and user manually changes amount to a different value, uncheck it
        if (!this.isUpdatingAmount) {
          const isFullRedemption = this.WithdrawFundForm.get('fullRedemption')?.value;
          if (isFullRedemption && faceValue) {
            const currentAmount = parseFloat(faceValue.toString().replace(/,/g, ''));
            if (currentAmount !== this.currentBalance) {
              this.WithdrawFundForm.get('fullRedemption')?.setValue(false, { emitEvent: false });
            }
          }
        }
      }) as Subscription,
    );

    this.changeSubscription.add(
      this.WithdrawFundForm.get('investorId')?.valueChanges.subscribe(() => {
        this.calculateBalance();
        this.updateAmountIfFullRedemption();
      }) as Subscription,
    );

    this.changeSubscription.add(
      this.WithdrawFundForm.get('type')?.valueChanges.subscribe(() => {
        this.calculateBalance();
        this.updateAmountIfFullRedemption();
      }) as Subscription,
    );

    this.changeSubscription.add(
      this.WithdrawFundForm.get('ccy')?.valueChanges.subscribe(() => {
        this.calculateBalance();
        this.updateAmountIfFullRedemption();
      }) as Subscription,
    );

    this.changeSubscription.add(
      this.WithdrawFundForm.get('fullRedemption')?.valueChanges.subscribe((isFullRedemption) => {
        if (isFullRedemption) {
          this.updateAmountIfFullRedemption();
        } else {
          this.isUpdatingAmount = true;
          this.WithdrawFundForm.get('faceValue')?.setValue('');
          this.isUpdatingAmount = false;
        }
      }) as Subscription,
    );
  }

  private calculateBalance(): void {
    const investorId = this.WithdrawFundForm.get('investorId')?.value;
    const type = this.WithdrawFundForm.get('type')?.value;
    const ccy = this.WithdrawFundForm.get('ccy')?.value;

    if (!investorId || !type || !ccy) {
      this.currentBalance = 0;
      return;
    }

    const matchingStatement = this.financialStatementsLatestList.find(
      (statement) => {
        return statement.investorId?.toString() === investorId?.toString() &&
          statement.type === type &&
          statement.ccy === ccy;
      }
    );

    this.currentBalance = matchingStatement ? matchingStatement.balance : 0;
  }

  private updateAmountIfFullRedemption(): void {
    const isFullRedemption = this.WithdrawFundForm.get('fullRedemption')?.value;
    
    this.isUpdatingAmount = true;
    if (isFullRedemption) {
      if (this.currentBalance > 0) {
        this.WithdrawFundForm.get('faceValue')?.setValue(this.currentBalance.toString());
      } else {
        this.WithdrawFundForm.get('faceValue')?.setValue('');
      }
    } else if (!isFullRedemption) {
      this.WithdrawFundForm.get('faceValue')?.setValue('');
    }
    this.isUpdatingAmount = false;
  }

  getInvestmentsById(investorId: string) {
    const queryParams = {
      perPage: 10000,
      investorId: investorId
    }
    this.investorsHttpService.getInvestmentsData(queryParams).subscribe({
      next: (response: InvestmentsResponseInterface) => {
        this.WithdrawFundForm.get('product')?.setValue(
          this.getUniqueValue(response.items, "product") === 'Multiple' ? '' : this.getUniqueValue(response.items, "product")
        );
      }
    });
  }

  setPrePopulatedValue() {
    const data = localStorage.getItem('financialStatementData');
    if (data) {
      this.financialStatementData = JSON.parse(data);
      if (this.financialStatementData && this.financialStatementData.length > 0) {
        this.WithdrawFundForm.get('date')?.setValue(this.currentDate);
        const ccy = this.getUniqueValue(this.financialStatementData, "ccy");
        const type = this.getUniqueValue(this.financialStatementData, "type");
        if (type === 'Multiple') {
          this.WithdrawFundForm.get('type')?.setValue('');
        } else {
          const months = type === 'Demand' || type === 'Fixed' ? 12 : type === 'Term' ? 36 : null;
          if (months !== null) this.WithdrawFundForm.get('months')?.setValue(months);
          this.WithdrawFundForm.get('type')?.setValue(type);
        }
        this.WithdrawFundForm.get('ccy')?.setValue(ccy === 'Multiple' ? '' : ccy);
      }
    }
  }

  private getUniqueValue(data: any[], key: string) {
    const uniqueValues = [...new Set(data.map((item) => item[key]))];
    return uniqueValues.length > 1 ? "Multiple" : uniqueValues[0];
  }

  handleFocusFaceValue(): void {
    if (isNaN(+this.WithdrawFundForm.value.faceValue)) {
      this.WithdrawFundForm.get('faceValue')?.patchValue('');
      return;
    }
    this.WithdrawFundForm.get('faceValue')?.patchValue(convertISONumberToNormal(+this.WithdrawFundForm.value.faceValue));
  }

  handleFocusOutFaceValue(): void {
    if (isNaN(+this.WithdrawFundForm.value.faceValue)) {
      this.WithdrawFundForm.get('faceValue')?.patchValue('');
      return;
    }
    this.WithdrawFundForm.get('faceValue')?.patchValue(formatSimpleNumber(this.WithdrawFundForm.value.faceValue));
  }
}
